class TabController {
    $onInit() {
        this.tabsCtrl.addTab(this);
    }
}

export default TabController;
